import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import { C } from "../constants";
import { LAYOUT } from "../constants/colors";

/**
 * Shared empty / trust state — used when plans or modules have nothing yet.
 */
export default function EmptyState({
  icon = "ti-calendar-event",
  title = "Nothing here yet",
  body = "",
  primaryLabel,
  onPrimary,
  secondaryLabel,
  onSecondary,
  tone = "neutral", // neutral | warn | error
}) {
  const border =
    tone === "error" ? `${C.error}40`
      : tone === "warn" ? `${C.warning}55`
        : C.border;
  const iconBg =
    tone === "error" ? C.errorBg
      : tone === "warn" ? C.warningBg
        : C.primarySoft;
  const iconColor =
    tone === "error" ? C.error
      : tone === "warn" ? "#143B56"
        : C.primary;

  return (
    <Box
      sx={{
        border: `1px solid ${border}`,
        borderRadius: `${LAYOUT.radius}px`,
        bgcolor: C.surface,
        px: { xs: 2.5, sm: 3.5 },
        py: { xs: 3.5, sm: 4.5 },
        textAlign: "center",
        boxShadow: "0 1px 2px rgba(10,14,23,0.04)",
      }}
    >
      <Box
        sx={{
          width: 52,
          height: 52,
          borderRadius: "14px",
          bgcolor: iconBg,
          color: iconColor,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 1.75,
        }}
      >
        <i className={`ti ${icon}`} style={{ fontSize: 24 }} />
      </Box>
      <Typography sx={{ fontSize: 16, fontWeight: 600, color: C.text, letterSpacing: "-0.02em" }}>
        {title}
      </Typography>
      {body ? (
        <Typography sx={{ mt: 0.75, fontSize: 13.5, color: C.muted, lineHeight: 1.55, maxWidth: 420, mx: "auto" }}>
          {body}
        </Typography>
      ) : null}
      {(primaryLabel || secondaryLabel) && (
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          justifyContent="center"
          sx={{ mt: 2.25 }}
        >
          {primaryLabel && (
            <Button
              variant="contained"
              disableElevation
              onClick={onPrimary}
              sx={{
                textTransform: "none",
                fontWeight: 700,
                borderRadius: `${LAYOUT.radiusSm}px`,
                bgcolor: C.primary,
                px: 2.25,
              }}
            >
              {primaryLabel}
            </Button>
          )}
          {secondaryLabel && (
            <Button
              variant="outlined"
              onClick={onSecondary}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                borderRadius: `${LAYOUT.radiusSm}px`,
                borderColor: C.border,
                color: C.text,
              }}
            >
              {secondaryLabel}
            </Button>
          )}
        </Stack>
      )}
    </Box>
  );
}
